import React from 'react'
import { useTheme } from '@mui/material/styles'
import { Star, StarBorder } from '@mui/icons-material'

export interface IReferenceCardRatingProps {
  rating: number
}

function ReferenceCardRating(props: IReferenceCardRatingProps) {
  const { rating } = props

  const theme = useTheme()
  const stars = [] as React.ReactNode[]
  const ratingClamped = Math.min(5, Math.max(1, Math.round(rating)))

  for (let i = 0; i < ratingClamped; i++) {
    stars.push(<Star />)
  }

  for (let i = ratingClamped; i < 5; i++) {
    stars.push(<StarBorder />)
  }

  return (
    <div>
      {stars}
    </div>
  )
}

export default React.memo(ReferenceCardRating)
